import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-appointment-cancel-dialog",
  template: `
    <p mat-dialog-content>
      Your appointment will not be created without a deposit. Are you sure you
      want to cancel?
    </p>

    <div mat-dialog-actions>
      <button mat-button (click)="close()">No</button>

      <button mat-button (click)="cancelRequest()">Cancel Request</button>
    </div>
  `,
})
export class AppointmentCancelDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AppointmentCancelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  close() {
    this.dialogRef.close();
  }

  cancelRequest() {
    window.location.reload();
  }
}
